export default __webpack_public_path__ + "static/media/index-head.d9406d39.png";